<template>
  <div class="banner">
    <!-- 名片 -->
    <div class="r_cardinfo">
      <div class="info-left">
        <div class="info-item">
          <span class="key" style="letter-spacing:28px">项目</span>
          <span>{{ cardinfo.projectname }}</span>
        </div>
        <div class="info-item">
          <span class="key" style="letter-spacing:28px">地址</span>
          <span>{{ cardinfo.ui_address }}</span>
        </div>
        <div class="info-item">
          <span class="key" style="letter-spacing:28px">电话</span>
          <span>{{ cardinfo.ui_mobile || cardinfo.mobile }}</span>
        </div>
        <div class="info-item">
          <span class="key" style="margin-right:30px">个人介绍</span>
          <span class="intro">{{ cardinfo.ui_personalprofile }}</span>
        </div>
      </div>
      <div class="info-right">
        <div class="avatar-wrap">
          <img :src="cardinfo.ui_headimg || cardinfo.headimgurl" alt="" />
        </div>
        <div class="sale-intro">{{ cardinfo.roleid | formatRole }}</div>
        <div class="sale-intro">{{ cardinfo.ui_name }}</div>
      </div>
    </div>
    <!-- 名片功能区 -->
    <div class="r_cardaction">
      <div
        class="cardaction_item"
        v-for="(item, index) in cardactionList"
        :key="index"
        @click="onCardEvent(index)"
      >
        <div class="cardaction_imgwrap">
          <img class="cardaction_img" :src="item.img" alt="" />
        </div>
        <div class="cardaction_title">{{ item.title }}</div>
      </div>
    </div>
    <!-- 楼盘轮播 -->
    <div class="r_recommend">
      <div class="common-header">
        <span>诚意推荐 </span>
        <span class="desc">{{ pcConfig.sincerere }}</span>
      </div>
      <div class="recommend-body">
        <swiper class="innner_swiper" ref="mySwiper" :options="swiperOption">
          <swiperSlide v-for="(item, index) in pcConfig.banner" :key="index">
            <img :src="item.main_img" @click="clickVr(item)" alt />
          </swiperSlide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="common-fotter"></div>
    </div>
    <!-- 户型图 -->
    <div
      class="r_housetype"
      v-if="pcConfig.houseimgs && pcConfig.houseimgs.length"
    >
      <div class="common-header">
        <span>{{ recommendHouseTxt }} </span>
        <span class="desc"></span>
      </div>
      <div class="house-body">
        <div class="house">
          <div
            class="house_item"
            v-for="(item, index) in pcConfig.houseimgs"
            :key="index"
            @click="clickHouse(item)"
          >
            <img class="house_img" :src="item.main_img" alt="" />
            <div class="house_tp">
              <div class="house_tags">
                <div
                  class="house_tag"
                  v-for="(tag, index) in item.tags"
                  :key="index"
                >
                  {{ tag }}
                </div>
              </div>
              <div class="house_price">{{ item.price }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 客户评价 -->
    <div class="r_evaluate">
      <div class="common-header">
        <div>
          <span>客户评价</span>
          <span class="desc">浏览人次{{ pcConfig.browsecount }}</span>
        </div>
        <span class="right" @click="clickEvaluate">
          <img src="http://assets.rurushishi.com/h5/img/tc1_edit.png" alt="" />
          <span>我也要评价</span>
        </span>
      </div>
      <div class="comment-body">
        <div
          class="list-group-item"
          v-for="(item, index) in discuss"
          :key="index"
        >
          <div class="item-left">
            <img :src="item.headimgurl" alt="" />
          </div>
          <div class="item-right">
            <div class="star-wrap">
              <img
                src="http://assets.rurushishi.com/h5/img/xing.png"
                alt=""
                v-for="(star, index) in item.nub"
                :key="index"
              />
              <span>{{ item.nub | formatSatisfaction }}</span>
            </div>
            <div class="star-tags">
              <span
                class="tag"
                v-for="(labelitem, index) in item.label"
                :key="index"
                >{{ labelitem }}</span
              >
            </div>
            <div class="comment-con">{{ item.specialevaluation }}</div>
            <div class="time">{{ item.createtime | formatTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- @touchstart="touchstartHandle('dragBox', $event)"
        @touchmove="touchmoveHandle('dragBox', $event)" -->
    <div ref="dragBox" class="r_saveimg" @click="clickShare">
      <img
        src="https://assets.rurushishi.com/web8245/wxd4c280bb15760f39/1580667694000-65.png"
        alt=""
      />
    </div>
    <ShowImg2
      v-if="showImg2.isShow"
      :my="showImg2"
      v-on:close="showImg2.isShow = false"
    ></ShowImg2>
    <HdkShareGuide
      v-if="isShowHdkShareGuide"
      v-on:close="closeHdkShareGuide"
    ></HdkShareGuide>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
const HdkShareGuide = () => import("@/components/hdk-share_guide.vue");

import "swiper/dist/css/swiper.css";
import * as comreq from "@/utils/comreq";
import util from "@/utils/utils";
const ShowImg2 = () => import("@/components/showimg2.vue");
import { mapState, mapMutations } from "vuex";
import request from "@/utils/request";
import global_ from "../../../../global.config";
export default {
  components: {
    swiper,
    swiperSlide,
    ShowImg2,
    HdkShareGuide
  },
  data() {
    return {
      discuss: [],
      cardinfo: {}, //卡片信息
      pcConfig: {}, //户型图
      recommendHouseTxt: "推荐户型", //推荐户型文本
      cardactionList: [], //卡片下面致电、导航等
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      },
      isShowHdkShareGuide: false, //是否显示分享弹框
      //用于拖拽
      coordinate: {
        client: {},
        elePosition: {}
      },
      swiperOption: {
        // pagination: {
        //   el: ".swiper-pagination"
        // },
        // on: {
        //   slideChange: function() {
        //     // console.log("slideChange===>activeIndex", this.activeIndex);
        //     // that100.changeSwiper(this.activeIndex);
        //   },
        //   slideNextTransitionStart() {}
        // }
        // pagination: ".swiper-pagination",
        // //循环
        // loop: true,
        // //每张播放时长3秒，自动播放
        // autoplay: 2000,
        // //滑动速度
        // speed: 1000
        // delay:1000
        autoplay: {
          delay: 2500
        },
        pagination: {
          el: ".swiper-pagination"
        }
      }
    };
  },
  filters: {
    formatTime: function(time) {
      var date = new Date(time);
      var m = date.getMonth() + 1;
      m <= 9 ? (m = "0" + m) : m;
      var d = date.getDate();
      d <= 9 ? (d = "0" + d) : d;
      var h = date.getHours();
      h <= 9 ? (h = "0" + h) : h;
      var m2 = date.getMinutes();
      m2 <= 9 ? (m2 = "0" + m2) : m2;
      var s = date.getSeconds();
      s <= 9 ? (s = "0" + s) : s;
      return (
        date.getFullYear() + "-" + m + "-" + d + " " + h + ":" + m2 + ":" + s
      );
    },
    formatSatisfaction: function(value) {
      var arrLabel = ["非常不满意", "不满意", "一般", "比较满意", "非常满意"];
      return arrLabel[value - 1];
    },
    formatRole: function(value) {
      var tmpObj = {
        roleid: value,
        rolename: ""
      };
      if (tmpObj.roleid == 2011) {
        tmpObj.rolename = "销售顾问";
      } else if (tmpObj.roleid == 2012) {
        tmpObj.rolename = "案场经理";
      } else if (tmpObj.roleid == 2013) {
        tmpObj.rolename = "销售经理";
      } else if (tmpObj.roleid == 2015) {
        tmpObj.rolename = "案场管理人";
      }
      return tmpObj.rolename;
    }
  },
  computed: {
    ...mapState([
      "userInfo",
      "pageInfo",
      "shareSpreadInfo",
      "isInMiniProgram",
      "receiveSpreadInfo"
    ])
  },
  methods: {
    //初始化卡片功能内容
    initCardactionList() {
      const baseUrl = "http://assets.rurushishi.com/h5/img/";
      this.cardactionList = [
        {
          img: `${baseUrl}tc1_zhidian.png`,
          title: "致电"
        },
        {
          img: `${baseUrl}tc1_daohang.png`,
          title: "导航"
        },
        {
          img: `${baseUrl}tc1_zixun.png`,
          title: "咨询"
        },
        {
          img: `${baseUrl}tc1_cuntu2.png`,
          title: "保存海报"
        },
        {
          img: `${baseUrl}tc1_weixin1.png`,
          title: "添加微信"
        }
      ];
    },

    //获取用户信息 卡片信息
    getUserInfo() {
      util.checkMapStateCallback(this, ["pageInfo", "userInfo"]).then(() => {
        let saleropenid = this.$route.query.saleropenid;
        // let saleropenid = "oj3y9wGThdLqhn0bZWOj7DeO2Tww";
        // let saleropenid = "ooSW7wCba7oABRNDGptiL95zK6Ho";
        if (this.global.isLoc && !saleropenid) {
          saleropenid = this.$openid;
        }
        comreq.fansInfo(saleropenid).then(fansInfo => {
          // console.log("fansInfo-----------", fansInfo);
          this.cardinfo = fansInfo;
          this.getPcConfig(saleropenid, fansInfo.projectid);
          this.getCommentList(saleropenid);
          util.setFoundShareCustomPageName(
            `我是${this.fansInfo.ui.name}，欢迎您随时联系`,
            `手机号：${this.fansInfo.ui.mobile} ${
              this.fansInfo.ui.wechatno
                ? "微信号：" + this.fansInfo.ui.wechatno
                : ""
            }`,
            this.pageInfo,
            this.shareSpreadInfo,
            false,
            ``,
            this.fansInfo.ui.headimg,
            "/vcard3/tabcard2"
          );
        });
      });
    },
    //获取评论列表
    getCommentList(saleropenid) {
      let that = this;
      request
        .get(global_.API_URL, {
          action: "/guext/EvaluationAction/selectNubThanThird",
          requestParam: {
            openid: saleropenid
          }
        })
        .then(function(response) {
          // console.log("response-----", response);
          if (response.obj) {
            that.evaluateScore = response.obj.avg;
            var tmpList = [];
            if (response.obj.list && response.obj.list.length > 0) {
              response.obj.list.forEach(function(item) {
                var labels = [];
                if (item.service == 1) {
                  labels.push("服务周到");
                }
                if (item.familiarize == 1) {
                  labels.push("熟悉项目");
                }
                if (item.feedback == 1) {
                  labels.push("反馈积极");
                }
                if (item.appearance == 1) {
                  labels.push("形象良好");
                }
                if (item.commentary == 1) {
                  labels.push("解说精彩");
                }
                if (item.knowledge == 1) {
                  labels.push("知识全面");
                }
                item.label = labels;
                tmpList.push(item);
              });
            }
            that.discuss = tmpList;
            // console.log("that.discuss----", that.discuss);
          }
        })
        .catch(err => {
          //   console.log(err);
        });
    },
    //获取户型图
    getPcConfig(saleropenid, projectid) {
      let that = this;
      request
        .get(global_.API_URL, {
          action: "/electroniccard/ElectronicCardAction/getElectronicCard",
          requestParam: {
            projectid: projectid,
            state: 1,
            masteropenid: saleropenid
          }
        })
        .then(function(data) {
          if (data.obj.houseimgs) {
            data.obj.houseimgs.forEach(item => {
              if (item.tags) {
                item.tags = item.tags.split(",");
              }
            });
          }
          that.pcConfig = data.obj;
          console.log("pcConfig----", that.pcConfig);
          if (data.btns) {
            data.btns.forEach(function(e) {
              if (e.type == 9) {
                that.pcConfig.callBtn = e;
              } else if (e.type == 10) {
                that.pcConfig.navBtn = e;
              } else if (e.type == 11) {
                that.pcConfig.askBtn = e;
              } else {
                that.pcConfig.btns.push(e);
              }
            });
          }
        })
        .catch(err => {
          //   console.log(err);
        });
    },
    //点击跳转到户型详情
    clickHouse(item) {
      var url = `${location.protocol}//${
        location.host
      }/h5/usercard_unit_details.html?id=${item.id}&cu_openid=${
        this.cardinfo.openid
      }`;
      console.log("clickHouse----", url);
      window.location.href = url;
    },
    //点击轮播
    clickVr(item) {
      //console.log(item)
    },
    //点击卡片功能区
    onCardEvent(index) {
      // console.log("index----", index);
      if (index == 0) {
        this.clickCall();
      } else if (index == 1) {
        this.clickAddress();
      } else if (index == 2) {
        this.clickChat();
      } else if (index == 3) {
        this.clickPoster();
      } else if (index == 4) {
        this.clickAddWeChat();
      }
    },
    //点击拨打电话
    clickCall() {
      util.makePhoneCall(this.cardinfo.ui_mobile || this.cardUserInfo.mobile);
    },
    //点击在线留言
    clickChat() {
      util.openShqcWebChat2(
        this.cardinfo.openid,
        this.cardinfo.ui_name || this.cardinfo.name
      );
    },
    //生成海报
    clickPoster() {
      var pageName = "";
      if (location.href.indexOf("zhbshf") > -1) {
        // 中海半山华府
        pageName = "usercard_createimg_zhbshf";
      } else if (location.href.indexOf("zhhp") > -1) {
        // 中海和平之门项目
        pageName = "usercard_createimg_zhhp";
      } else if (location.href.indexOf("zhsyzhc") > -1) {
        // 中海和悦府 沈阳中海城
        pageName = "usercard_createimg_zhsyzhc";
      } else if (location.href.indexOf("zhty") > -1) {
        // 中海天誉
        pageName = "usercard_createimg_zhty";
      } else if (location.href.indexOf("zhhytx") > -1) {
        // 中海寰宇天下
        pageName = "usercard_createimg_zhhytx";
      } else if (location.href.indexOf("zhhzhu.") > -1) {
        // 中海红著
        pageName = "usercard_createimg_zhhzhu";
      } else if (location.href.indexOf("qczhj.") > -1) {
        // 泉城中海家
        pageName = "usercard_createimg_qczhj";
      } else if (location.href.indexOf("kqcjnzyf.") > -1) {
        pageName = "usercard_createimg_kqcjnzyf";
      } else {
        pageName = "usercard_createimg";
      }
      var url = `${location.protocol}//${
        location.host
      }/h5/${pageName}.html?openid=${this.cardinfo.openid}&myopenid=${
        this.$openid
      }&mypassport=${this.$passport}&pageid=${
        this.cardinfo.pageid
      }&cardversion=1`;
      window.location.href = url;
    },
    //点击导航
    clickAddress() {
      // console.log("clickAddress---", this.pcConfig);
      // 传btns里面type=9的id
      //   if (this.pcConfig.navBtn && this.pcConfig.navBtn.id) {
      //     this.saveBtnClick(this.pcConfig.navBtn.id);
      //   }
      window.open(this.pcConfig.navigationurl);
    },
    //点击微信
    clickAddWeChat() {
      if (this.cardinfo) {
        if (!this.isInMiniProgram && this.cardinfo.wxqr) {
          // h5环境下有二维码，弹出二维码
          this.showImg2 = {
            isShow: true,
            url: this.cardinfo.wxqr,
            width: "50%",
            intro: `扫码，添加${this.cardinfo.ui_name}的微信！`
          };
        } else if (this.cardinfo.ui_weixin) {
          util.messageBox(`我的微信号是：${this.cardinfo.ui_weixin}`);
        } else {
          util.messageBox("亲，您可以用电话联系我");
        }
      } else {
        util.messageBox("亲，您可以用电话联系我");
      }
    },
    //打开引导
    clickShare() {
      // console.log("object");
      // 不管在小程序还是H5分享都改成线框指引
      this.isShowHdkShareGuide = true;
    },
    //关闭引导
    closeHdkShareGuide() {
      this.isShowHdkShareGuide = false;
    },
    //点击我也要评论
    clickEvaluate() {
      var url = `${location.protocol}//${
        location.host
      }/h5/usercard_evaluate.html?openid=${this.cardinfo.openid}&myopenid=${
        this.$openid
      }&mypassport=${this.$passport}&pageid=${this.cardinfo.pageid}`;
      //   console.log("clickEvaluate----", url);
      window.location.href = url;
    },
    saveBtnClick: function(btnid = "") {
      let that = this;
      request
        .get(global_.API_URL, {
          params: {
            action: "/electroniccard/ElectronicCardAction/saveBtnClick",
            requestParam: {
              obj: {
                cardid: that.pcConfig.card.id, //电子名片模板id
                masteropenid: that.cardinfo.openid, //当前电子名片所属人的openid
                uuid: that.pcConfig.uuid, //前端生成的唯一标识
                btnid: btnid //功能按钮的id
              }
            }
          }
        })
        .then(function(response) {
          if (response.obj) {
            var data = response.obj;
          }
        })
        .catch(function(error) {
          // console.log(error);
        });
    },
    touchstartHandle(refName, e) {
      let element = e.targetTouches[0];
      // 记录点击的坐标
      this.coordinate.client = {
        x: element.clientX,
        y: element.clientY
      };
      // 记录需要移动的元素坐标
      this.coordinate.elePosition.left = this.$refs[refName].offsetLeft;
      this.coordinate.elePosition.top = this.$refs[refName].offsetTop;
      e.preventDefault();
    },
    touchmoveHandle(refName, e) {
      let element = e.targetTouches[0];
      // 根据初始 client 位置计算移动距离(元素移动位置=元素初始位置+光标移动后的位置-光标点击时的初始位置)
      let x =
        this.coordinate.elePosition.left +
        (element.clientX - this.coordinate.client.x);
      let y =
        this.coordinate.elePosition.top +
        (element.clientY - this.coordinate.client.y);
      // 限制可移动距离，不超出可视区域
      x =
        x <= 0
          ? 0
          : x >= innerWidth - this.$refs[refName].offsetWidth
          ? innerWidth - this.$refs[refName].offsetWidth
          : x;
      y =
        y <= 0
          ? 0
          : y >= innerHeight - this.$refs[refName].offsetHeight
          ? innerHeight - this.$refs[refName].offsetHeight
          : y;
      // 移动当前元素
      this.$refs[refName].style.left = x + "px";
      this.$refs[refName].style.top = y + "px";
    }
  },
  mounted() {
    this.initCardactionList();
    this.getUserInfo();
  }
};
</script>

<style scoped lang="stylus">
// px 转换 rem
p2r(designpx) {
  $rem = 100px;
  return (designpx / $rem) rem;
}
.banner {
  background-color: #fff;
  min-height: 100vh;
  margin-top: 0.3rem;
}
.r_cardinfo
  padding p2r(30px) p2r(20px)
  background-color: #fff;
  box-shadow: 0 0 1rem #dbdbdb;
  border-radius: 6px;
  margin: 0 0.3rem;
  z-index: 1;
  position: relative;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  box-shadow: 0 0 1rem #dbdbdb;
  border-radius: 6px;
  align-items: center;
  .info-left
    flex 1
    .info-item
      margin-bottom p2r(10px)
    .key
      color: #808080;
    .intro
      line-height p2r(40px)
  .info-right
    display flex
    flex-direction column
    justify-content center
    align-items center
    margin-left p2r(10px)
    .avatar-wrap
      width p2r(100px)
      height p2r(100px)
      border-radius 50%
      overflow hidden
    img
      width 100%
      height 100%
    .sale-intro
      margin-top p2r(10px)


.r_cardaction
    display flex
    background-color rgb(34, 59, 82)
    padding-top p2r(40px)
    margin-bottom p2r(40px)
    margin-top p2r(-40px)
    box-sizing border-box
    .cardaction_item
        display flex
        flex 1
        flex-direction column
        justify-content center
        align-items center
        padding p2r(30px) 0
        .cardaction_imgwrap
            width p2r(50px)
            height p2r(50px)
        .cardaction_img
            width 100%
            height 100%
        .cardaction_title
            color #fff
            line-height p2r(50px)
.r_recommend
    padding 0 p2r(30px)
    .common-header
        display flex
        align-items center
        background-color #fff
        border-left p2r(12px) solid #2ca9df
        border-top-right-radius p2r(10px)
        border-top-left-radius p2r(10px)
        padding-left p2r(20px)
        font-weight 700
        color #333
        line-height p2r(44px)
        .desc
            font-size p2r(20px)
            color #666666;
            padding-left p2r(14px)
    .recommend-body
        padding p2r(20px) p2r(20px) 0 p2r(20px)
        box-sizing border-box
        width 100%
        .swiper-slide
            width 100% !important
            height 4.22rem
            img
                display:block
                width 100%
                height 100%
                object-fit cover
        .swiper-pagination-bullets
            bottom 28px
    .common-fotter
        width 100%
        height p2r(100px)

.r_housetype
    padding 0 p2r(30px)
    .common-header
        display flex
        align-items center
        background-color #fff
        border-left p2r(12px) solid #2ca9df
        border-top-right-radius p2r(10px)
        border-top-left-radius p2r(10px)
        padding-left p2r(20px)
        font-weight 700
        color #333
        line-height p2r(44px)
    .house-body
        padding p2r(30px)
        box-sizing border-box
        width 100%
        .house
            width 100%
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .house_item
                width 48%
                border 1px solid #E6E6E6
                border-radius 5px
                margin-top p2r(10px)
                img
                    width: 100%;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                .house_tp
                    background-color: #E6E6E6;
                    padding p2r(20px)
                    .house_tags
                        margin-bottom: 5px;
                        .house_tag
                            display inline-block
                            margin-bottom p2r(10px)
                            color: #101010;
                            background-color: #FFFFFF;
                            border-radius: 3px;
                            margin-right: p2r(20px);
                            padding: 1px;
                    .house_price
                        line-height p2r(42px)
                        font-size p2r(30px)
.r_evaluate
    padding 0 p2r(30px)
    .common-header
        display flex
        align-items center
        justify-content space-between
        background-color #fff
        border-left p2r(12px) solid #2ca9df
        border-top-right-radius p2r(10px)
        border-top-left-radius p2r(10px)
        padding-left p2r(20px)
        font-weight 700
        color #333
        line-height p2r(44px)
        .desc
            font-size p2r(20px)
            color #666666;
            padding-left p2r(14px)
        .right
            font-size p2r(30px)
            color #666666
            img
                width p2r(30px)
                height p2r(30px)
                margin-right p2r(6px)
            // span
    .comment-body
        padding p2r(30px)
        box-sizing border-box
        width 100%
        .list-group-item
            display flex
            padding 0
            border 0
            border-radius 0
            padding-bottom p2r(20px)
            border-bottom 1px solid #e8e8e8
            margin-bottom p2r(20px)
            .item-left
                width p2r(100px)
                height p2r(100px)
                border-radius 50%
                overflow hidden
                margin-right p2r(20px)
                img
                    width 100%
                    height 100%
            .item-right
                flex 1
                .star-wrap
                    display flex
                    align-items center
                    height p2r(36px)
                    img
                        width p2r(20px)
                        height p2r(20px)
                        vertical-align: baseline;
                .star-tags
                    // margin 0 p2r(20px)
                    .tag
                        font-size: 13px;
                        padding: p2r(10px);
                        background-color: #f89414;
                        margin-left: 0;
                        margin-top: p2r(10px);
                        margin-right: p2r(10px);
                        display: inline-block;
                        color: white;
                .comment-con
                    margin p2r(20px) 0
.r_saveimg
    position: fixed;
    right: p2r(20px);
    bottom: p2r(100px);
    z-index: 1;
    img
        width p2r(100px)
        height p2r(100px)
</style>
